import styled from 'styled-components';
import backgroundImage from '../../assets/images/img_gerdau_background.jpg';

export const EGerdauHomeContainer = styled.div`
  background-image: url(${backgroundImage});
  background-position: 50%;
  background-size: cover;
  height: 100vh;
  width: 100vw;
`;

export const EGerdauHomeCard = styled.div`
  position: fixed;
  width: 90%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.25rem;
  max-width: 31.25rem;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 2rem 0.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 2rem;
  }
`;
